import React, { useState, useMemo, useEffect, useRef } from 'react'
import { SelectMultiple as SelectMultipleTea, Bubble } from 'tea-component'
// import en_US from "tea-component/es/i18n/locale/en_US";

import SelectButton from '@/pages/dashboard/components/SelectButton'

import './index.scss'
import { Props, Options } from './types'

const SelectMultiple = (props: Props) => {
  const {
    value,
    defaultValue,
    options = [],
    label,
    allDescribe,
    lastOneWarn = true,
    isHaveAll = true,
    isHaveTooltip = true,
    disabledConfig,
    lastOneMessage = 'This option is the last one, after unchecking the competitor game will not have data.',
    onChange,
    ...othersProps
  } = props
  const { lmitLength, disableToolTips} = disabledConfig || {}
  const bindClassName = useRef(label?.replace(/\s/g, '') + Date.now().toString(36))
  const defaultValueInner = options?.map(item => item.value) as string[]
  const nameMap = useMemo(() => {
    const map: any = {}
    options?.forEach(item => {
      if (!(item.text && item.value)) return
      map[item.text] = item
    })
    return map
  }, [options])
  const getNameValue = (value: any, options: Options = []) => {
    return options?.filter?.((item: any) => value.includes(item.value))?.map?.((item: any) => item.text) ?? []
  }

  const selectHistory = useRef([] as any)
  const [selectValue, setSelectValue] = useState(getNameValue(value ?? defaultValue ?? defaultValueInner, options))
  const [bubbleVisible, setBubbleVisible] = useState(false)
  const [dropdownVisible, setDropdownVisible] = useState(false)
  let valueList = options?.filter(item => selectValue?.includes(item.text))?.map(item => item.text)
  if (options?.length > 0 && options?.length === selectValue?.length) {
    valueList = allDescribe ? [allDescribe] : ['All']
  }

  const selectOptions = useMemo(() => {
    return options.map?.((item) => {
      const disabled =  disabledConfig ? (!selectValue?.includes((item.text ?? item.value)) && selectValue.length>=lmitLength):false;
      return ({
        ...item,
        value: item.text ?? item.value,
        disabled:disabled,
        text: (
          <p className='select-multiple-item'>
            {item.icon && <img className='select-multiple-item-icon' src={item.icon} />}
            <span className='select-multiple-item-text'>{item.text}</span>
          </p>
        ),
        tooltip: isHaveTooltip ? item.text : ((disableToolTips && disabled )? disableToolTips : '')
      })
    })
  }, [options,selectValue])

  const handleChange = (nameValue: any) => {
    // 内部使用 nameValue 互相连接，外部使用真实的 value 传递
    const { value, sourceValue } = (() => {
      const value: string[] = []
      const sourceValue: any[] = []
      nameValue?.forEach((item: any) => {
        value.push(nameMap?.[item]?.value)
        sourceValue.push(nameMap?.[item])
      })
      return {
        value,
        sourceValue
      }
    })()
    onChange?.(value)
    setSelectValue(nameValue)
  }

  const handleOpenChange = (visible: any) => {
    selectHistory.current = []
    setDropdownVisible(visible)
  }

  useEffect(() => {
    if (!value || !options) return
    setSelectValue(getNameValue(value, options))
  }, [value])

  // 记录选择历史
  useEffect(() => {
    selectHistory.current = [
      ...selectHistory.current,
      selectValue
    ]
  }, [JSON.stringify(selectValue)])

  // 选择到最后一条时展示提示框，关闭弹窗重置显示逻辑
  useEffect(() => {
    setBubbleVisible(
      selectHistory?.current?.[selectHistory.current?.length - 2]?.length > 0 &&
      selectValue?.length === 1 && lastOneWarn &&
      dropdownVisible
    )
  }, [selectValue, lastOneWarn, dropdownVisible])

  return (
    <>
      <Bubble
        dark
        visible={bubbleVisible}
        content={lastOneMessage}
      >
        <SelectMultipleTea
          {...othersProps}
          className={`${bindClassName.current} ${othersProps?.className}`}
          appearance='button'
          boxClassName='select-multiple-container'
          // matchButtonWidth={true}
          staging={false}
          value={selectValue}
          defaultValue={selectValue}
          button={<SelectButton label={label} selectList={valueList as any} />}
          onChange={handleChange}
          options={selectOptions}
          onOpenChange={handleOpenChange}
          searchable
          closeOnScroll={false}
          positionFixed={false}
          popupContainer={() => document.querySelector(`.${bindClassName.current}`)}
          overlayClassName={"select-multiple-container__overlay"}
          {...(isHaveAll ?{allOption: {
            value: 'All',
            text: 'All'
          }}: {})}
        />
      </Bubble>
    </>
  )
}

export default SelectMultiple
